/* index.js */

"use strict";

const _ = require("lodash");

// const Button = require("@gluenetworks/steve_ui_core").Control.Action.Button;
// const { labelByTypeData } = require("../CustomFieldsConstants");

module.exports = {
    actionIconsFormatter,
    dateFormatter,
    sizeFormatter,
    checksumFormatter,
};

function dateFormatter(row, cell, value) {
    let convertedDate = toLocaleString(value);
    const convertedDateEl = document.createElement("div");
    convertedDateEl.classList.add("date-column");
    // let titleString = "";
    if (value === 0) {
        convertedDate = "N/A";
    }

    convertedDateEl.setAttribute("title", convertedDate);
    convertedDateEl.innerHTML = convertedDate;
    return convertedDateEl.outerHTML;
}

function toLocaleString(val) {
    let d = new Date(val);
    if (Object.prototype.toString.call(d) === "[object Date]" && !isNaN(d.getTime())) {
        return d.toLocaleDateString() + " " + d.toLocaleTimeString();
    } else {
        return "";
    }
}

function sizeFormatter(row, cell, value) {
    if (!_.isNumber(value)) {
        return "";
    }
    return parseInt(value).toLocaleString(undefined, {minimumFractionDigits: 0}) + " bytes";
}

function actionIconsFormatter(row, cell, value, columnDef, dataContext) {
    let container = document.createElement("div");
    container.classList.add("results-action-container");

    const devRestoreIcon = document.createElement("actionable-icon-gl");
    if (!dataContext.hasRestorePerm || dataContext.deviceData.os !== dataContext.os) {
        devRestoreIcon.classList.add("disabled");
    }
    devRestoreIcon.dataset.icon = "devicemanager.restore";
    devRestoreIcon.dataset.role = "run";
    devRestoreIcon.dataset.configId = dataContext.id;
    devRestoreIcon.setAttribute("title", "Restore device from backup");
    container.appendChild(devRestoreIcon);

    const devSnapshotIcon = document.createElement("actionable-icon-gl");
    if (!dataContext.snapshotId) {
        devSnapshotIcon.classList.add("disabled");
    }
    devSnapshotIcon.dataset.icon = "configdrift.eye";
    devSnapshotIcon.dataset.role = "snapshot";
    devSnapshotIcon.dataset.snapshotId = dataContext.snapshotId;
    devSnapshotIcon.setAttribute("title", "View snapshot");
    container.appendChild(devSnapshotIcon);

    const devConfIcon = document.createElement("actionable-icon-gl");
    devConfIcon.dataset.icon = "common.trash_bin";
    devConfIcon.dataset.role = "delete";
    devConfIcon.dataset.configId = dataContext.id;
    devConfIcon.setAttribute("title", "Delete backup");
    container.appendChild(devConfIcon);

    return container.outerHTML;
}

function checksumFormatter(row, cell, value) {
    let checksumEl = document.createElement("span");
    checksumEl.innerText = value;
    checksumEl.title = value;
    // Other option for PE-11234
    // let checksumEl = document.createElement("input");
    // checksumEl.classList.add("checksum-value");
    // checksumEl.setAttribute("value", value);
    // checksumEl.readOnly = true;
    return checksumEl.outerHTML;
}
